<template>
  <div ref="container" :style="`height:${height}px`"></div>
</template>

<script>
// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
import * as echarts from "echarts/core";

// 引入柱状图图表，图表后缀都为 Chart
import { BarChart } from "echarts/charts";

// 引入柱状图图表，图表后缀都为 Chart
import { LineChart } from "echarts/charts";

// 引入饼图图表，图表后缀都为 Chart
import { PieChart } from "echarts/charts";

// 引入提示框，标题，直角坐标系，数据集，内置数据转换器组件，组件后缀都为 Component
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  LegendComponent,
  DataZoomComponent,
  ToolboxComponent,
  GraphicComponent
} from "echarts/components";

// 标签自动布局，全局过渡动画等特性
import { LabelLayout, UniversalTransition } from "echarts/features";

// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer } from "echarts/renderers";

// 注册必须的组件
echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  LegendComponent,
  DataZoomComponent,
  ToolboxComponent,
  GraphicComponent,
  LabelLayout,
  UniversalTransition,
  CanvasRenderer,
  BarChart,
  LineChart,
  PieChart
]);

export default {
  props: {
    height: {
      type: Number,
      default: 150
    },
    option: {
      type: Object,
      required: true,
      default() {
        return {};
      }
    }
  },
  watch: {
    option(val) {
      this.myChart && this.myChart.setOption(val, true);
    }
  },
  mounted() {
    this.init();
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    init() {
      this.myChart = echarts.init(this.$refs["container"], {
        width: "auto"
      });
      this.myChart.setOption(this.option);
    },
    handleResize() {
      this.myChart && this.myChart.resize();
    }
  }
};
</script>
